// extracted by css-extract-rspack-plugin
export default {"root":"Tab_root__dI4V9","error":"Tab_error__dZCTs","selected":"Tab_selected__p4Yru","badge":"Tab_badge__ewZ5E"};